import { Entity, Member, OwnershipRecord, Loan } from '../types/ownership'

export const CURRENT_ENTITY: Entity = {
  id: 'ent-001',
  name: 'Acme Holdings LLC',
  recordType: 'Entity',
}

export const AVAILABLE_MEMBERS: Member[] = [
  {
    id: 'mem-001',
    name: 'John Smith',
    recordType: 'Individual',
    email: 'john.smith@example.com',
  },
  {
    id: 'mem-002',
    name: 'Sarah Johnson',
    recordType: 'Individual',
    email: 'sarah.j@example.com',
  },
  {
    id: 'mem-003',
    name: 'Michael Chen',
    recordType: 'Individual',
    email: 'm.chen@example.com',
  },
  {
    id: 'mem-004',
    name: 'Emily Davis',
    recordType: 'Individual',
    email: 'emily.d@example.com',
  },
  {
    id: 'mem-005',
    name: 'David Wilson',
    recordType: 'Individual',
    email: 'dwilson@example.com',
  },
]

// Helper to get date string relative to today
const getDate = (daysOffset: number) => {
  const date = new Date()
  date.setDate(date.getDate() + daysOffset)
  return date.toISOString().split('T')[0]
}

export const INITIAL_OWNERSHIP_RECORDS: OwnershipRecord[] = [
  {
    id: 'own-001',
    memberId: 'mem-001',
    memberName: 'John Smith',
    entityId: 'ent-001',
    ownershipPercentage: 40,
    effectiveStartDate: getDate(-365), // Started 1 year ago
    isPrimaryMember: true,
    createdDate: getDate(-365),
  },
  {
    id: 'own-002',
    memberId: 'mem-002',
    memberName: 'Sarah Johnson',
    entityId: 'ent-001',
    ownershipPercentage: 30,
    effectiveStartDate: getDate(-180), // Started 6 months ago
    isPrimaryMember: false,
    createdDate: getDate(-180),
  },
  {
    id: 'own-003',
    memberId: 'mem-003',
    memberName: 'Michael Chen',
    entityId: 'ent-001',
    ownershipPercentage: 10,
    effectiveStartDate: getDate(-90),
    effectiveEndDate: getDate(-1), // Ended yesterday (Historical)
    isPrimaryMember: false,
    createdDate: getDate(-90),
  },
  {
    id: 'own-004',
    memberId: 'mem-003',
    memberName: 'Michael Chen',
    entityId: 'ent-001',
    ownershipPercentage: 15,
    effectiveStartDate: getDate(0), // Starts today
    isPrimaryMember: false,
    createdDate: getDate(0),
  },
]

export const OPEN_LOANS: Loan[] = [
  {
    id: 'loan-001',
    loanNumber: 'LN-2024-001',
    borrowerName: 'Acme Holdings LLC',
    loanAmount: 500000,
    status: 'Active',
    entityId: 'ent-001',
    createdDate: getDate(-120),
  },
  {
    id: 'loan-002',
    loanNumber: 'LN-2024-042',
    borrowerName: 'Acme Holdings LLC',
    loanAmount: 1250000,
    status: 'Active',
    entityId: 'ent-001',
    createdDate: getDate(-60),
  },
  {
    id: 'loan-003',
    loanNumber: 'LN-2024-089',
    borrowerName: 'Acme Holdings LLC',
    loanAmount: 75000,
    status: 'Pending',
    entityId: 'ent-001',
    createdDate: getDate(-10),
  },
  {
    id: 'loan-004',
    loanNumber: 'LN-2023-992',
    borrowerName: 'Acme Holdings LLC',
    loanAmount: 300000,
    status: 'Active',
    entityId: 'ent-001',
    createdDate: getDate(-400),
  },
]
